"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DefaultIcon_1 = __importDefault(require("./icons/DefaultIcon"));
const ColorType_1 = __importDefault(require("./enums/ColorType"));
const Button = (props) => {
    var action = typeof props.action == "undefined" ? "button" : props.action;
    var iconColor;
    var labelClass = props.label === "" ? `btn--no-text` : ``;
    switch (props.type) {
        case "primary":
            iconColor = ColorType_1.default.White;
            break;
        case "secondary":
            iconColor = ColorType_1.default.MidGrey;
            break;
        case "tertiary":
            iconColor = ColorType_1.default.MidGrey;
            break;
        case "delete":
            iconColor = ColorType_1.default.White;
            break;
        case "input":
            iconColor = ColorType_1.default.MidGrey;
            break;
    }
    return (react_1.default.createElement("button", { type: action, onClick: () => props.handlerFunction(), className: props.state === "enabled"
            ? `btn btn-${props.type} ${labelClass}`
            : `btn btn-${props.type} ${labelClass} btn-${props.type}--disabled` },
        react_1.default.createElement("div", { className: props.label === ""
                ? "btn-content btn-content--no-text"
                : "btn-content" },
            react_1.default.createElement(DefaultIcon_1.default, { size: props.type === "input" ? "20" : "24", type: props.icon, color: iconColor }),
            props.type === "input" ? react_1.default.createElement(react_1.default.Fragment, null) : react_1.default.createElement("p", null, props.label))));
};
exports.default = Button;
